import React from "react"
import { getIn } from "formik"
import FormLabel from "./formLabel"

function FormRadioButtonOptions({ ...props }) {
  const { textDesc, form, field, options, className } = props

  const errors = getIn(form.errors, field.name)
  const touched = getIn(form.touched, field.name)

  const handleRadioButton = (buttonName, buttonValue) => {
    form.setFieldValue(buttonName, buttonValue)
  }

  return (
    <div className="marginBottom19px">
      <div>
        <FormLabel text={textDesc} className={className} />
        <div className="marginTop10px">
          <div className="d-block">
            <div
              className={
                "fontSize18px height50 horizontal-align backgroundGrey cursorPointer borderRadius8 YesNobutton " +
                (field.value === options[0] ? "tick" : "")
              }
              onClick={() => {
                handleRadioButton(field.name, options[0])
              }}
              role="button"
              tabIndex="0"
            >
              {options[0]}
            </div>
            <div
              className={
                "fontSize18px height50 horizontal-align backgroundGrey cursorPointer borderRadius8 YesNobutton " +
                (field.value === options[1] ? "tick" : "")
              }
              onClick={event => {
                handleRadioButton(field.name, options[1])
              }}
              role="button"
              tabIndex="0"
            >
              {options[1]}
            </div>
          </div>
          {errors && touched && <span className="InputError">{errors}</span>}
        </div>
      </div>
    </div>
  )
}
export default FormRadioButtonOptions
